/* eslint-disable no-param-reassign */
import produce from 'immer';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const createPageSlice = (set) => ({
  loadingDashConfigs: true,
  dashData: null,
  setLoadingDashConfigs: (loadingDashConfigs) =>
    set(
      produce((state) => {
        state.loadingDashConfigs = loadingDashConfigs;
      }),
    ),
  setDashData: (dashData) =>
    set(
      produce((state) => {
        dashData.devolutions.reasons.sort((a, b) =>
          a.name.localeCompare(b.name),
        );
        state.dashData = dashData;
      }),
    ),
});

const usePageStore = create(
  devtools(
    (...a) => ({
      ...createPageSlice(...a),
    }),
    { name: 'Emails' },
  ),
);

export default usePageStore;
